<!-- Saved Searches -->
<div #section
    id="savedSearches"
    class="agpr-userPreferences-subSection"
>
    <h4 class="agpr-userPreferences-subSection-heading">
        {{ 'Discover.userPreferences.savedSearches' | localize}}
    </h4>
    <div class="agpr-userPreferences-subSection-content">
        <agpr-user-preference-filter-wrapper
            [id]="'Discover_userPreferences_savedSearches_filters'"
            [items]="targetingSearches"
            [initialValues]="discoverPreferences.savedSearchesPrefs.defaultFilters"
            [defaultFilters]="defaultSavedSearchesFilters"
            (filterChange)="updateDirtyFlag()"
        ></agpr-user-preference-filter-wrapper>
    </div>

    <div class="agpr-userPreferences-subSection-content">
        <h5 class="agpr-userPreferences-subSection-subHeading">
            {{'Discover.userPreferences.defaultSearch' | localize}}
        </h5>
        <div class="agpr-discoverPreferences-search">
            <agpr-checkbox
                [id]="'discoverUserPreferences_includePrivateContacts_checkbox'"
                label="Discover.userPreferences.defaultSearch.includeContacts"
                [binary]="true"
                [(ngModel)]="savedSearchesDefaultSearch.includePrivateContacts"
                (ngModelChange)="updateDirtyFlag()"
            ></agpr-checkbox>
            <div class="agpr-discoverPreferences-search-includeExcludeContainer">
                <agpr-include-exclude-chips
                    [id]="'targetingSearch_regions_includeExclude'"
                    [(idModel)]="savedSearchesDefaultSearch.locations"
                    (idModelChange)="updateDirtyFlag()"
                    placeholder="Discover.userPreferences.defaultSearch.locations.placeholder"
                    headerLabel="Discover.userPreferences.defaultSearch.locations"
                    labelLookupField="displayString"
                    idField="collectionId"
                    [autocompleteOptions]="{
                        suggestionsFetcher: targetingGeographyService.searchGeographicLocationsWithAccountRestrictions.bind(targetingGeographyService)
                    }"
                    [lookupById]="targetingGeographyService.getByGeographyIds.bind(targetingGeographyService)"
                    [showIncludeAll]="false"
                    (browseAll)="showRegionBrowser($event)"
                    headingLevel="4"
                ></agpr-include-exclude-chips>
            </div>

            <div class="agpr-discoverPreferences-search-includeExcludeContainer">
                <agpr-include-exclude-chips
                    [id]="'targetingSearch_languages_includeExclude'"
                    [(idModel)]="savedSearchesDefaultSearch.languages"
                    (idModelChange)="updateDirtyFlag()"
                    placeholder="Discover.userPreferences.defaultSearch.languages.placeholder"
                    labelLookupField="name"
                    idField="id"
                    headerLabel="Discover.userPreferences.defaultSearch.languages"
                    [lookupById]="localizationService.getLanguagesById.bind(localizationService)"
                    [autocompleteOptions]="{
                        suggestionsFetcher: localizationService.autocompleteLanguages.bind(localizationService)
                    }"
                    (browseAll)="showLanguageBrowser($event)"
                    headingLevel="4"
                ></agpr-include-exclude-chips>
            </div>
        </div>
    </div>

    <div class="agpr-userPreferences-subSection-content">
        <h5 class="agpr-userPreferences-subSection-subHeading">
            {{'AccountPreferences.defaultResults' | localize}}
        </h5>
        <div class="agpr-discoverPreferences-results">
            <div>
                <div class="agpr-discoverPreferences-results-dropdown-label">
                    {{ 'AccountPreferences.defaultResults.sortOrder' | localize }}
                </div>
                <div class="agpr-discoverPreferences-results-dropdown">
                    <agpr-dropdown
                        [id]="'savedSearches_results_sort_dropdown_type'"
                        placeholder="AccountPreferences.defaultResults.sortType"
                        [options]="defaultSavedSearchesDisplaySettings.sortTypeOptions"
                        [(ngModel)]="defaultSavedSearchesDisplaySettings.selectedSortType"
                        (ngModelChange)="defaultSavedSearchesDisplaySettings.handleSelectionChange($event, 'type'); updateDirtyFlag()"
                        label="AccountPreferences.defaultResults.sortType"
                    ></agpr-dropdown>
                    <agpr-dropdown
                        [id]="'savedSearches_results_sort_dropdown_order'"
                        class="agpr-discoverPreferences-results-dropdown-sortDirection"
                        placeholder="AccountPreferences.defaultResults.sortDirection"
                        [options]="defaultSavedSearchesDisplaySettings.sortDirectionOptions"
                        [(ngModel)]="defaultSavedSearchesDisplaySettings.selectedSortDirection"
                        (ngModelChange)="defaultSavedSearchesDisplaySettings.handleSelectionChange($event, 'direction'); updateDirtyFlag()"
                        label="AccountPreferences.defaultResults.sortDirection"
                    ></agpr-dropdown>
                </div>
            </div>
            <div>
                <agpr-dropdown
                    [id]="'savedSearches_results_page_dropdown'"
                    placeholder="AccountPreferences.defaultResults.pageSize"
                    [options]="defaultSavedSearchesDisplaySettings.pageSizeOptions"
                    [(ngModel)]="defaultSavedSearchesDisplaySettings.selectedPageSize"
                    (ngModelChange)="defaultSavedSearchesDisplaySettings.handleSelectionChange($event, 'pageSize'); updateDirtyFlag()"
                    label="AccountPreferences.defaultResults.pageSize"
                ></agpr-dropdown>
            </div>
        </div>
    </div>
</div>

<!-- Targeted Lists -->
<div #section
    [id]="'targetedLists'"
    class="agpr-userPreferences-subSection"
>
    <h4 class="agpr-userPreferences-subSection-heading">
        {{ 'Discover.userPreferences.targetedLists' | localize}}
    </h4>
    <div class="agpr-userPreferences-subSection-content">
        <agpr-user-preference-filter-wrapper
            [id]="'Discover_userPreferences_targetingLists_filters'"
            [items]="targetingLists"
            [initialValues]="discoverPreferences.targetedListsPrefs.defaultFilters"
            [defaultFilters]="defaultTargetedListsFilters"
            (filterChange)="updateDirtyFlag()"
        ></agpr-user-preference-filter-wrapper>
    </div>

    <div class="agpr-userPreferences-subSection-content">
        <h5 class="agpr-userPreferences-subSection-subHeading">
            {{'AccountPreferences.defaultResults' | localize}}
        </h5>
        <div class="agpr-discoverPreferences-results">
            <div>
                <div class="agpr-discoverPreferences-results-dropdown-label">
                    {{ 'AccountPreferences.defaultResults.sortOrder' | localize }}
                </div>
                <div class="agpr-discoverPreferences-results-dropdown">
                    <agpr-dropdown
                        [id]="'targetedLists_results_sort_dropdown_type'"
                        placeholder="AccountPreferences.defaultResults.sortType"
                        [options]="defaultTargetedListsDisplaySettings.sortTypeOptions"
                        [(ngModel)]="defaultTargetedListsDisplaySettings.selectedSortType"
                        (ngModelChange)="defaultTargetedListsDisplaySettings.handleSelectionChange($event, 'type'); updateDirtyFlag()"
                        label="AccountPreferences.defaultResults.sortType"
                    ></agpr-dropdown>
                    <agpr-dropdown
                        [id]="'targetedLists_results_sort_dropdown_order'"
                        class="agpr-discoverPreferences-results-dropdown-sortDirection"
                        placeholder="AccountPreferences.defaultResults.sortDirection"
                        [options]="defaultTargetedListsDisplaySettings.sortDirectionOptions"
                        [(ngModel)]="defaultTargetedListsDisplaySettings.selectedSortDirection"
                        (ngModelChange)="defaultTargetedListsDisplaySettings.handleSelectionChange($event, 'direction'); updateDirtyFlag()"
                        label="AccountPreferences.defaultResults.sortDirection"
                    ></agpr-dropdown>
                </div>
            </div>
            <div>
                <agpr-dropdown
                    [id]="'targetedLists_results_page_dropdown'"
                    placeholder="AccountPreferences.defaultResults.pageSize"
                    [options]="defaultTargetedListsDisplaySettings.pageSizeOptions"
                    [(ngModel)]="defaultTargetedListsDisplaySettings.selectedPageSize"
                    (ngModelChange)="defaultTargetedListsDisplaySettings.handleSelectionChange($event, 'pageSize'); updateDirtyFlag()"
                    label="AccountPreferences.defaultResults.pageSize"
                ></agpr-dropdown>
            </div>
        </div>
    </div>
</div>

<!-- Distributions -->
<div #section
    [id]="'distributions'"
    class="agpr-userPreferences-subSection"
>
    <h4 class="agpr-userPreferences-subSection-heading spacer">
        {{ 'UserPreferences.distributions' | localize}}
    </h4>
    <div
        class="agpr-discoverPreferences-subSection-chart"
        [agprLoading]="loadingDistributionStats"
    >
        <agpr-distribution-usage-chart
            [totalUsagePercentage]="totalUsagePercentage"
            [accountInfo]="currentAccount"
            [resetDate]="resetDate"
            [quotaInfo]="quotaInfo"
            [quotaOverTime]="quotaOverTime"
            (openBuyQuotaDialog)="openBuyQuotaDialog()"
        ></agpr-distribution-usage-chart>
    </div>

    <div class="agpr-userPreferences-subSection-content">
        <agpr-user-preference-filter-wrapper
            [id]="'Discover_userPreferences_distributions_filters'"
            [items]="distributions"
            [initialValues]="discoverPreferences.distributionsPrefs.defaultFilters"
            [defaultFilters]="defaultDistributionsFilters"
            (filterChange)="updateDirtyFlag()"
        ></agpr-user-preference-filter-wrapper>
    </div>

    <div class="agpr-userPreferences-subSection-content">
        <h5 class="agpr-userPreferences-subSection-subHeading">
            {{'Discover.userPreferences.distributions.reportDisplaySettings' | localize}}
        </h5>
        <div class="agpr-discoverPreferences-search">
            <agpr-checkbox
                [id]="'discoverUserPreferences_distributions_enableMppEstimates'"
                label="Discover.userPreferences.distributions.mppAdjustedEstimates"
                [binary]="true"
                [(ngModel)]="enableMppEstimates"
                (ngModelChange)="updateDirtyFlag()"
            ></agpr-checkbox>
        </div>
    </div>

    <div class="agpr-userPreferences-subSection-content">
        <h5 class="agpr-userPreferences-subSection-subHeading">
            {{'Discover.userPreferences.defaultDetails' | localize}}
        </h5>
        <div class="agpr-discoverPreferences-fields">
            <agpr-text-input #fromNameInput
                placeholder = "Discover.userPreferences.defaultDetails.from.placeholder"
                label="Discover.userPreferences.defaultDetails.from"
                tooltip="Discover.userPreferences.defaultDetails.from.tooltip"
                [(ngModel)]="distributionDefaultDetails.fromName"
                (ngModelChange)="updateDirtyFlag()"
                [id]="'Discover_userPreferences_defaultDetails_fromNameInput'"
                (blur)="assessFromName()"
                (keyup)="assessFromName()"
                [maxLength]="100"
                [icon]="assessmentMessages.fromName.length > 0 ? 'fa-regular fa-duotone fa-circle-exclamation' :
                        distributionDefaultDetails.fromName.length > 0 ? 'fa-regular fa-duotone fa-circle-check' : null"
                [iconPopoverTemplate]="assessmentMessages.fromName.length > 0 ? fromNamePopover : null"
                [iconPopoverStyleClass]="'agpr-discoverPreferences-hintsPopover'"
                [iconPopoverText]="assessmentMessages.fromName.toString()"
            >
            </agpr-text-input>
            <ng-template #fromNamePopover>
                <div class="agpr-discoverPreferences-fields-assessment-popover">
                    <span
                        class="agpr-discoverPreferences-fields-assessment-popover-icon agpr-message-icon fa-regular fa-circle-info"
                        aria-hidden="true"
                    ></span>
                    <div class="agpr-discoverPreferences-fields-assessment-popover-content">
                        <p
                            *ngFor="let message of assessmentMessages.fromName"
                            class="agpr-discoverPreferences-fields-assessment-popover-content-message"
                        >
                            {{ message }}
                        </p>
                    </div>
                </div>
            </ng-template>
            <span #fromNameLiveRegion class="sr-only" role="region" aria-live="polite"></span>

            <agpr-email-text-input
                label="Discover.userPreferences.defaultDetails.to"
                tooltip="Discover.userPreferences.defaultDetails.to.tooltip"
                [id]="'Discover_userPreferences_defaultDetails_replyEmailInput'"
                [(ngModel)]="distributionDefaultDetails.replyEmail"
                (ngModelChange)="updateDirtyFlag()"
                [placeholder]="'Discover.userPreferences.defaultDetails.to.placeholder'"
                (emailChange)="onEmailChange($event)"
            ></agpr-email-text-input>
        </div>
    </div>

    <div class="agpr-userPreferences-subSection-content">
        <h5 class="agpr-userPreferences-subSection-subHeading">
            {{ 'Discover.userPreferences.defaultRecipients.header' | localize }}
            <span
                role="img"
                class="fa-regular fa-circle-info agpr-discoverPreferences-infoCircle"
                [agprTooltip]="'Discover.userPreferences.defaultRecipients.tooltip'"
            ></span>
        </h5>
        <agpr-email-chips
            [id]="'defaultRecipientsips'"
            [(value)]="defaultRecipients"
            (valueChange)="updateDirtyFlag()"
            placeholder="Common.mailingLists.editRecipientDialog.email.placeholder"
            [errorKey]="'invalidEmailFormat' | localize"
            [showDuplicateErrorKey]="'Common.forms.email.duplicateEmail'"
            [ariaLabel]="'Common.mailingLists.editRecipientDialog.email.placeholder'"
        ></agpr-email-chips>
    </div>

    <div class="agpr-userPreferences-subSection-content">
        <h5 class="agpr-userPreferences-subSection-subHeading">
            {{'Discover.distribution.footer.settings' | localize}}
        </h5>
        <div class="agpr-footer">
            <div class="agpr-userPreferences-subSection-subDivider">
                <h6 class="agpr-headerH3-light" >
                    {{'Discover.distribution.footer.settings.senderAddress' | localize}}
                </h6>
                <span
                    role="img"
                    class="fa-regular fa-circle-info agpr-footer-infoCircle"
                    agprTooltip="Discover.distribution.footer.settings.senderAddress.tooltip"
                ></span>
            </div>
            <div class="agpr-discoverPreferences-footer-content">
                <agpr-text-input
                    class="agpr-textField-input"
                    label="Discover.distribution.footer.settings.addressPreText"
                    [id]="'addressPreText_input'"
                    [(ngModel)]="defaultFooter.addressPreText"
                    (ngModelChange)="emitFooterChanges()"
                    [maxLength]="255"
                    [placeholder]="'Discover.distribution.footer.settings.addressPreText.placeholder' | localize"
                    [bottomMargin]="false"
                ></agpr-text-input>
                <agpr-text-input
                    class="agpr-textField-input"
                    label="Discover.distribution.footer.settings.company"
                    [id]="'company_input'"
                    tooltip="Discover.distribution.footer.settings.company.tooltip"
                    [(ngModel)]="defaultFooter.company"
                    (ngModelChange)="emitFooterChanges()"
                    [maxLength]="255"
                    [placeholder]="'Discover.distribution.footer.settings.company.placeholder' | localize"
                    [bottomMargin]="false"
                ></agpr-text-input>
                <div class="agpr-footer-label-gridContainer">
                    <div class="agpr-inputGroup">
                        <agpr-text-input
                            class="agpr-textField-input"
                            label="Discover.distribution.footer.settings.streetAddress"
                            [id]="'streetAddress_input'"
                            [(ngModel)]="defaultFooter.streetAddress"
                            (ngModelChange)="emitFooterChanges()"
                            [maxLength]="255"
                            [placeholder]="'Discover.distribution.footer.settings.streetAddress.placeholder' | localize"
                            [bottomMargin]="false"
                        ></agpr-text-input>
                    </div>
                    <div class="agpr-inputGroup">
                        <agpr-text-input
                            class="agpr-textField-input"
                            label="Discover.distribution.footer.settings.city"
                            [id]="'city_input'"
                            [(ngModel)]="defaultFooter.city"
                            (ngModelChange)="emitFooterChanges()"
                            [maxLength]="255"
                            [placeholder]="'Discover.distribution.footer.settings.city.placeholder' | localize"
                            [bottomMargin]="false"
                        ></agpr-text-input>
                    </div>
                    <div class="agpr-inputGroup">
                        <agpr-text-input
                            class="agpr-textField-input"
                            label="Discover.distribution.footer.settings.province"
                            [id]="'province_input'"
                            [(ngModel)]="defaultFooter.province"
                            (ngModelChange)="emitFooterChanges()"
                            [maxLength]="255"
                            [placeholder]="'Discover.distribution.footer.settings.province.placeholder' | localize"
                            [bottomMargin]="false"
                        ></agpr-text-input>
                    </div>
                    <div class="agpr-inputGroup">
                        <div class="agpr-footer-countryDropdown">
                            <agpr-autocomplete
                                [id]="'footer_country'"
                                placeholder="Discover.distribution.footer.settings.country.placeholder"
                                label="Discover.distribution.footer.settings.country"
                                [(ngModel)]="defaultFooter.country"
                                (ngModelChange)="emitFooterChanges()"
                                [forceSelection]="false"
                                [suggestionsFetcher]="journodexRegionsService.autoCompleteCountryLabelOnly.bind(journodexRegionsService)"
                                [clearOnBlur]="false"
                            ></agpr-autocomplete>
                        </div>
                    </div>
                </div>
                <div class="agpr-footer-postalCode">
                    <agpr-text-input
                        class="agpr-textField-input"
                        label="Discover.distribution.footer.settings.postalCode"
                        [id]="'postalCode_input'"
                        [(ngModel)]="defaultFooter.postalCode"
                        (ngModelChange)="emitFooterChanges()"
                        [maxLength]="255"
                        [placeholder]="'Discover.distribution.footer.settings.postalCode.placeholder' | localize"
                        [bottomMargin]="false"
                    ></agpr-text-input>
                </div>
            </div>
            <div class="agpr-userPreferences-subSection-subDivider">
                <h6 class="agpr-headerH3-light">
                    {{'Discover.distribution.footer.settings.contactInfo' | localize}}
                </h6>
                <span
                    role="img"
                    class="fa-regular fa-circle-info agpr-footer-infoCircle"
                    agprTooltip="Discover.distribution.footer.settings.contactInfo.tooltip"
                ></span>
            </div>
            <div
                class="agpr-footer-contactInfo"
                role="radiogroup"
                [attr.aria-label]="'Discover.distribution.footer.settings.contactInfo' | localize"
            >
                <div class="agpr-footer-contactInfo-inputGroup">
                    <agpr-radio
                        [id]="'emailContactRadioButton'"
                        [value]="contactInfoTypesEnum.email"
                        label="Discover.distribution.footer.settings.email"
                        hiddenLabel="Discover.distribution.footer.settings.email"
                        [(ngModel)]="contactInfoType"
                        (onClick)="setContactInfoType(contactInfoTypesEnum.email)"
                    ></agpr-radio>
                    <agpr-email-text-input
                        *ngIf="contactInfoType === contactInfoTypesEnum.email"
                        [id]="'senderEmail_input'"
                        [(ngModel)]="defaultFooter.senderEmail"
                        (ngModelChange)="emitFooterChanges()"
                        [placeholder]="'Discover.distribution.footer.settings.email.placeholder'"
                        [ariaLabel]="'Discover.distribution.footer.settings.email.placeholder'"
                        maxLength="254"
                        (emailChange)="onEmailChange($event)"
                    ></agpr-email-text-input>
                </div>
                <div class="agpr-footer-contactInfo-inputGroup">
                    <agpr-radio
                        [id]="'phoneContactRadioButton'"
                        [value]="contactInfoTypesEnum.phone"
                        label="Discover.distribution.footer.settings.phone"
                        hiddenLabel="Discover.distribution.footer.settings.phone"
                        [(ngModel)]="contactInfoType"
                        (onClick)="setContactInfoType(contactInfoTypesEnum.phone)"
                    ></agpr-radio>
                    <agpr-text-input
                        *ngIf="contactInfoType === contactInfoTypesEnum.phone"
                        ariaLabel="Discover.distribution.footer.settings.phone.placeholder"
                        class="agpr-textField-input"
                        [id]="'senderPhone_input'"
                        [(ngModel)]="defaultFooter.senderPhone"
                        (ngModelChange)="emitFooterChanges()"
                        [maxLength]="255"
                        [placeholder]="'Discover.distribution.footer.settings.phone.placeholder' | localize"
                    ></agpr-text-input>
                </div>
            </div>
            <div class="agpr-userPreferences-subSection-subDivider">
                <h6 class="agpr-headerH3-light">
                    {{'Discover.distribution.footer.settings.unsubLink' | localize}}
                </h6>
                <span
                    role="img"
                    class="fa-regular fa-circle-info agpr-footer-infoCircle"
                    agprTooltip="Discover.distribution.footer.settings.unsub.tooltip"
                ></span>
            </div>
            <div class="agpr-discoverPreferences-footer-content">
                <agpr-dropdown
                    [id]="'discoverPreferences_unsubLanguage'"
                    [options]="unsubLanguageDropdownOptions"
                    [(ngModel)]="selectedUnsubLanguageOption"
                    (ngModelChange)="onSelectUnsubLanguage($event);"
                    label="Discover.distribution.footer.settings.unsubLinkLanguage"
                >
                </agpr-dropdown>
            </div>
        </div>
    </div>

    <div class="agpr-userPreferences-subSection-content">
        <h5 class="agpr-userPreferences-subSection-subHeading">
            {{'Discover.distribution.footer.settings.Preview' | localize}}
        </h5>
        <agpr-twig
            class="agpr-block-rendered"
            [twigTemplate]="footerBlock?.type.twig"
            [data]="twigData"
            (renderedOutput)="setRenderedOutput($event)"
        ></agpr-twig>
    </div>

    @if (dataConnectionService.hasEmailAccountProvision$ | async) {
        <div class="agpr-userPreferences-subSection-content">
            <h4 class="agpr-userPreferences-subSection-subHeading">
                {{'Discover.userPreferences.defaultEmailAccount.label' | localize}}
            </h4>
            <agpr-dropdown
                [id]="'default_emailAccount_dropdown'"
                [options]="emailAccountOptions"
                [(ngModel)]="selectedDefaultEmailAccount"
                (ngModelChange)="updateDirtyFlag()"
            ></agpr-dropdown>
        </div>
    }
</div>
